(() => {
  const root = document.querySelector('[data-gtp-kaching-test]');
  if (!root) return;
  const actions = root.querySelector('[data-gtp-kaching-actions]');
  const countdowns = document.querySelectorAll('[data-gtp-dispatch-countdown]');
  function updateDispatchCountdown() {
    if (!countdowns.length) return;
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const remaining = Math.max(0, Math.ceil((midnight - now) / 1000));
    const value = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60]
      .map(value => String(value).padStart(2, '0')).join(':');
    countdowns.forEach(countdown => { countdown.textContent = value; });
  }
  updateDispatchCountdown();
  if (!window.__gtpDispatchCountdownTimer) {
    window.__gtpDispatchCountdownTimer = window.setInterval(updateDispatchCountdown, 1000);
  }

  const form = root.querySelector('form');
  const submit = form.querySelector('[data-add-to-cart]');
  const total = form.querySelector('[data-gtp-atc-total]');
  function openKachingCart() {
    if (window.kachingCartApi?.openCart) {
      window.kachingCartApi.openCart({refetchCart:true});
      return true;
    }

    // Kaching Cart no longer exposes kachingCartApi on every storefront.
    // Its own cart trigger remains the supported handoff and refreshes the
    // drawer before opening it, so use that instead of falling back to a
    // theme-specific/custom cart.
    const cartTrigger = document.querySelector('#cart-icon-bubble');
    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }

    return false;
  }
  function syncButtonTotal() {
    const block = root.querySelector('kaching-bundles-block');
    const price = block?.pricing?.()?.discountedPrice?.formatted;
    if (price && total && total.textContent !== ` · ${price}`) total.textContent = ` · ${price}`;
    const message = root.querySelector('[data-gtp-klarna-text]');
    const payment = message?.closest('.gtp-kaching-klarna');
    if (price && payment) {
      // Kaching supplies the active market's formatted total, including discounts.
      const digits = price.replace(/[^0-9.,]/g, '');
      const decimal = digits.match(/[.,](\d{1,2})$/);
      const amount = decimal
        ? Number(digits.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1])
        : Number(digits.replace(/[.,]/g, ''));
      if (Number.isFinite(amount) && amount > 0 && payment.dataset.currency) {
        const installment = new Intl.NumberFormat(payment.dataset.locale || 'en', {
          style: 'currency', currency: payment.dataset.currency
        }).format(amount / 4);
        const copy = `Pay in 4 of ${installment} with Klarna for eligible customers.`;
        if (message.textContent !== copy) message.textContent = copy;
      }
    }
  }
  let submitting = false;
  root.addEventListener('submit', async event => {
    if (event.target !== form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting) return;
    const errorBox = form.querySelector('.product-form__error-message-wrapper');
    const errorText = form.querySelector('.product-form__error-message');
    const showError = message => {
      if (errorText) errorText.textContent = message;
      errorBox?.classList.remove('hidden');
    };
    const block = root.querySelector('kaching-bundles-block');
    if (block?.validateItemSelection && !block.validateItemSelection().valid) return;
    submitting = true;
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    errorBox?.classList.add('hidden');
    try {
      // Kaching Bundles intercepts this native form payload and adds its gifts,
      // accessory quantities and discount properties. Suppress auto-open here
      // so there is one explicit drawer open after a successful response.
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js?opens_cart=false`, {
        method:'POST', body:new FormData(form), headers:{Accept:'application/json'}
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add your selection. Please try again.');
      if (!openKachingCart()) {
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      }
    } catch (error) {
      showError(error.message || 'Unable to update the cart. Please try again.');
    } finally {
      submitting = false;
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  }, true);
  root.addEventListener('items-changed', () => requestAnimationFrame(syncButtonTotal));

  const priceHeader = document.querySelector('[data-kaching-price-header]');
  const klarna = root.querySelector('.gtp-kaching-klarna');

  function syncHeaderPrice() {
    if (!priceHeader) return;
    const selected = Array.from(root.querySelectorAll('.kaching-bundles__bar--selected'))
      .find(bar => !bar.closest('.kaching-bundles__checkbox-upsells'));
    if (!selected) return;
    const price = selected.querySelector('.kaching-bundles__bar-price');
    const compare = selected.querySelector('.kaching-bundles__bar-full-price');
    const amount = priceHeader.querySelector('[data-kaching-header-price]');
    const original = priceHeader.querySelector('[data-kaching-header-compare]');
    if (price) amount.textContent = price.textContent.trim();
    original.textContent = compare ? compare.textContent.trim() : '';
    original.hidden = !original.textContent;
  }
  let expanded = false;
  let queued = false;
  const settingsNode = document.querySelector(`script.kaching-bundles-deal-block-settings[data-product-id="${root.dataset.productId}"]`);
  const settings = settingsNode ? JSON.parse(settingsNode.textContent) : {};
  let selectedBar = settings.preselectedDealBarId;
  const giftNames = {
    '9174708355291': '30-Day Transformation Exercise Book (digital)',
    '9482555326683': 'Coach Kris Workouts — Lifetime Access',
    '9482555359451': 'Rayofi App Access',
    '8905522446555': 'Footpad & Bar Set'
  };
  root.querySelectorAll('[data-kaching-tier]').forEach(panel => {
    const quantity = panel.dataset.kachingTier === 'dual' ? 2 : 1;
    const bar = (settings.dealBars || []).find(item => item.quantity === quantity);
    const gifts = bar ? bar.freeGifts || [] : [];
    const container = panel.querySelector('[data-kaching-included-gifts]');
    if (!container || !gifts.length) return;
    const heading = document.createElement('h4');
    heading.textContent = 'Free add-ons included';
    container.append(heading);
    gifts.forEach(gift => {
      const row = document.createElement('div');
      row.className = 'gtp-kaching-included-gift';
      const name = document.createElement('span');
      name.textContent = giftNames[gift.productGID.split('/').pop()] || gift.text.replace(/^\+\s*/, '');
      const badge = document.createElement('strong');
      badge.textContent = 'FREE';
      row.append(name, badge);
      container.append(row);
    });
  });
  function syncIncluded() {
    const bar = (settings.dealBars || []).find(item => item.id === selectedBar);
    const tier = bar && bar.quantity === 2 ? 'dual' : 'single';
    root.querySelectorAll('[data-kaching-tier]').forEach(panel => { panel.hidden = panel.dataset.kachingTier !== tier; });
  }
  root.addEventListener('deal-bar-selected', event => {
    selectedBar = event.detail.dealBarId;
    syncIncluded();
    if (!event.detail.preselected) {
      const bar = (settings.dealBars || []).find(item => item.id === selectedBar);
      const blockId = bar && bar.quantity === 2 ? 'tier_dual' : 'tier_single';
      document.dispatchEvent(new CustomEvent('gtp:tier-change', {detail:{tierBlockId:blockId, blockId, userInitiated:true}}));
    }
    schedule();
  }, true);
  // Move native upsell nodes, preserving Kaching's listeners and discount state.
  // The leading plus adds one more through Kaching's native quantity control.
  const videoDialog = document.getElementById('gtp-dock-video');
  const videoFrame = videoDialog.querySelector('[data-gtp-video-frame]');
  let videoOpener;
  videoDialog.querySelector('[data-gtp-video-close]').addEventListener('click', () => videoDialog.close());
  videoDialog.addEventListener('click', event => {
    if (event.target === videoDialog) {
      const bounds = videoDialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) videoDialog.close();
    }
  });
  videoDialog.addEventListener('close', () => {
    videoFrame.replaceChildren();
    document.documentElement.classList.remove('gtp-video-open');
    videoOpener?.focus();
  });
  root.addEventListener('keydown', event => {
    if (event.target.closest('[data-gtp-dock-video]')) event.stopPropagation();
  }, true);
  root.addEventListener('click', event => {
    const watch = event.target.closest('[data-gtp-dock-video]');
    if (watch) {
      event.preventDefault();
      event.stopImmediatePropagation();
      videoOpener = watch;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/vIBe11AXYtY?autoplay=1&playsinline=1&rel=0';
      frame.title = 'GYMDOCK in action';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      videoFrame.replaceChildren(frame);
      videoDialog.showModal();
      document.documentElement.classList.add('gtp-video-open');
      return;
    }
    const row = event.target.closest('.kaching-bundles__checkbox-upsells__upsell');
    if (!row) return;
    const plus = event.target.closest('.kaching-bundles__checkbox-upsells__checkbox');
    const quantity = row.querySelector('.kaching-bundles__quantity-selector__input');
    const minus = row.querySelector('.kaching-bundles__quantity-selector__button');
    if (minus?.contains(event.target) && quantity && Number(quantity.value) <= 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      row.querySelector('.kaching-bundles__bar-main').click();
      return;
    }
    if (plus && row.classList.contains('kaching-bundles__bar--selected') && quantity) {
      event.preventDefault();
      event.stopImmediatePropagation();
      row.querySelectorAll('.kaching-bundles__quantity-selector__button')[1]?.click();
    }
  }, true);
  root.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key)) return;
    const row = event.target.closest('.kaching-bundles__checkbox-upsells__upsell');
    const minus = row?.querySelector('.kaching-bundles__quantity-selector__button');
    const quantity = row?.querySelector('.kaching-bundles__quantity-selector__input');
    if (event.target === minus && quantity && Number(quantity.value) <= 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      row.querySelector('.kaching-bundles__bar-main').click();
    }
  }, true);
  function syncQuantityButtons(list) {
    list.querySelectorAll('.kaching-bundles__quantity-selector').forEach(selector => {
      const minus = selector.querySelector('.kaching-bundles__quantity-selector__button');
      const quantity = selector.querySelector('input');
      if (!minus || !quantity) return;
      minus.setAttribute('aria-disabled', 'false');
      minus.tabIndex = 0;
      minus.setAttribute('aria-label', Number(quantity.value) <= 1 ? 'Remove accessory' : 'Decrease quantity');
    });
  }
  function syncDocks(list) {
    const entries = settings.checkboxUpsells?.upsells || [];
    // These configured products render in the same order as their native rows.
    if (entries.some(item => item.productSource !== 'selected')) return;
    const rows = Array.from(list.querySelectorAll('.kaching-bundles__checkbox-upsells__upsell'));
    const bar = (settings.dealBars || []).find(item => item.id === selectedBar);
    rows.forEach((node, index) => {
      const productId = entries[index]?.productGID?.split('/').pop();
      if (!['9005993033947', '9279546130651'].includes(productId)) return;
      const isDual = productId === '9279546130651';
      const active = isDual === (bar?.quantity === 2);
      node.dataset.gtpDock = isDual ? 'dual' : 'single';
      if (!node.querySelector('[data-gtp-dock-video]')) {
        const watch = document.createElement('button');
        watch.type = 'button';
        watch.className = 'gtp-dock-watch';
        watch.dataset.gtpDockVideo = '';
        watch.setAttribute('aria-haspopup', 'dialog');
        watch.setAttribute('aria-controls', 'gtp-dock-video');
        watch.setAttribute('aria-label', 'See GYMDOCK in action');
        watch.innerHTML = '<span aria-hidden="true">▶</span> See it in action';
        node.append(watch);
      }
      // Deselect through the app before hiding, so hidden add-ons never reach cart.
      if (!active && node.classList.contains('kaching-bundles__bar--selected')) {
        node.querySelector('.kaching-bundles__bar-main').click();
      }
      node.hidden = !active;
    });
  }
  const more = document.createElement('button');
  more.type = 'button';
  more.className = 'gtp-kaching-more';
  more.setAttribute('aria-expanded', 'false');
  more.addEventListener('click', () => {
    expanded = !expanded;
    update();
  });
  function update() {
    queued = false;
    syncIncluded();
    syncHeaderPrice();
    syncButtonTotal();
    const gifts = root.querySelector('.kaching-bundles__progressive-gifts');
    const payments = actions.querySelector('.gtp-kaching-payment-icons');
    // Keep the original gift controls and their app listeners; only change placement.
    const giftSlot = root.querySelector('[data-gtp-gifts-slot]');
    if (gifts && giftSlot && gifts.parentElement !== giftSlot) giftSlot.append(gifts);
    const giftsHeading = gifts?.querySelector('.kaching-bundles__progressive-gifts__title');
    if (giftsHeading && giftsHeading.textContent !== '4 free extras with your Go-Tone') {
      giftsHeading.textContent = '4 free extras with your Go-Tone';
    }

    const upsells = root.querySelector('.kaching-bundles__checkbox-upsells');
    if (!upsells) return;
    // Move our CTA, not Kaching's managed controls, to preserve app state.
    if (upsells.previousElementSibling !== actions) upsells.before(actions);
    const list = upsells.querySelector('.kaching-bundles__checkbox-upsells__upsells');
    if (!list) return;
    syncDocks(list);
    syncQuantityButtons(list);
    const rows = Array.from(list.children).filter(row => !row.hidden && row.matches('.gtp-kaching-dock, .kaching-bundles__checkbox-upsells__upsell'));
    const title = upsells.querySelector('.kaching-bundles__block-title');
    if (title && title.textContent.includes('10%')) title.textContent = title.textContent.replace('10%', '25%');
    if (rows.length <= 3) return;
    list.id = 'gtp-kaching-accessories';
    more.setAttribute('aria-controls', list.id);
    const fourth = rows[3];
    const height = Math.max(280, fourth.getBoundingClientRect().top - list.getBoundingClientRect().top + fourth.offsetHeight / 2);
    const value = expanded ? 'none' : `${height}px`;
    if (list.style.maxHeight !== value) list.style.maxHeight = value;
    list.classList.toggle('gtp-kaching-collapsed', !expanded);
    more.setAttribute('aria-expanded', String(expanded));
    const label = expanded ? 'View fewer accessories' : 'View more accessories';
    if (more.textContent !== label) more.textContent = label;
    if (list.nextElementSibling !== more) list.after(more);
    rows.forEach((row, i) => { row.inert = !expanded && i >= 3; });
  }
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  new MutationObserver(records => {
    if (records.some(record => !Array.from(countdowns).some(countdown => countdown.contains(record.target)))) schedule();
  }).observe(root, {childList: true, subtree: true, characterData:true, attributes:true, attributeFilter:['class']});
  window.addEventListener('resize', schedule);
  window.addEventListener('kaching-bundles-initialized', schedule);
  root.addEventListener('load', schedule, true);
  schedule();

  const gallery = document.querySelector('.gtp-social-comments__grid');
  if (gallery) {
    const dialog = document.createElement('dialog');
    dialog.className = 'gtp-comment-lightbox';
    dialog.setAttribute('aria-label', 'Customer comment');
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close comment');
    const image = document.createElement('img');
    const caption = document.createElement('p');
    dialog.append(close, image, caption);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    gallery.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey) return;
      event.preventDefault();
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || 'Customer comment';
      caption.textContent = image.alt;
      dialog.showModal();
    });
    const note = document.querySelector('.gtp-social-comments__note');
    if (note) note.textContent = 'Tap a tile to read. Comments from the Go-Tone community; some refer to earlier models.';
  }
})();

// Short display names keep native cart controls usable on narrow screens.
(() => {
  if (!document.querySelector('[data-gtp-kaching-test]')) return;
  const names = {
    '9005993033947': 'Single GYMDOCK',
    '9279546130651': 'Dual GYMDOCK (pair)',
    '8902860013787': 'SIXPACK Abs Roller',
    '8975882387675': 'Go-Tone Carry Bag',
    '8865401929947': 'Go-Tone Grip',
    '8905522446555': 'Footpad & Bar Set'
  };
  function syncCartDocks(cart) {
    const deviceLine = Array.from(cart.querySelectorAll('.kaching-cart-item:not(.kaching-cart-extra-item)'))
      .find(item => item.querySelector('a[href*="/products/go-tone-pro"]'));
    const quantity = Number(deviceLine?.querySelector('input')?.value || 0);
    const id = quantity >= 2 ? 9279546130651 : quantity === 1 ? 9005993033947 : 0;
    const present = id && cart.querySelector(`.kaching-cart-item[data-product-id="${id}"]`);
    const value = present ? '0' : String(id);
    if (document.body.dataset.gtpCartDock !== value) document.body.dataset.gtpCartDock = value;
  }
  const refresh = () => {
    document.querySelectorAll('.kaching-cart-item[data-product-id], .kaching-product-upsell-item[data-product-id]').forEach(item => {
      const name = names[item.dataset.productId];
      const title = item.querySelector('.kaching-cart-item__title, .kaching-product-upsell-item__title');
      if (name && title && title.textContent !== name) title.textContent = name;
    });
    const cart = document.querySelector('kaching-cart-drawer');
    if (cart) syncCartDocks(cart);
  };
  const attach = () => {
    const cart = document.querySelector('kaching-cart-drawer');
    if (!cart) return false;
    new MutationObserver(refresh).observe(cart, {childList:true, subtree:true, characterData:true});
    refresh();
    return true;
  };
  if (!attach()) {
    const observer = new MutationObserver(() => { if (attach()) observer.disconnect(); });
    observer.observe(document.body, {childList:true, subtree:true});
  }
})();
